if (!customElements.get('experts-slider')) {
  class ExpertsSlider extends HTMLElement {
    selectors = {
      arrows: {
        arrowLeft: '[experts-slider="arrows-wrapper"] .arrow-left',
        arrowRight: '[experts-slider="arrows-wrapper"] .arrow-right',
      },
      mediaWrapper: '[experts-slider="media"]',
      dotsSlider: '[experts-slider="dots-slider"]',
      dot: '[experts-slider="dots-slider"] .swiper-slide',
      contentSlider: '[experts-slider="content-slider"]',
    };

    classes = {
      active: 'active',
    };

    contentSlider = undefined;
    dotsSlider = undefined;
    #activeIndex = 0;

    get activeIndex() {
      return this.#activeIndex;
    }

    set activeIndex(index) {
      const indexNum = Number(index);

      if (Number.isNaN(indexNum)) {
        console.error(`${index} is not a valid value for Active index`);
        return activeIndex;
      }

      if (indexNum <= 0) {
        return (this.#activeIndex = 0);
      }

      if (indexNum >= this.maxIndex) {
        return (this.#activeIndex = this.maxIndex);
      }

      return (this.#activeIndex = indexNum);
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        arrows: {
          arrowLeft: document.querySelector(this.selectors.arrows.arrowLeft),
          arrowRight: document.querySelector(this.selectors.arrows.arrowRight),
        },
        mediaWrapper: document.querySelector(this.selectors.mediaWrapper),
        dotsSlider: document.querySelector(this.selectors.dotsSlider),
        dots: [...document.querySelectorAll(this.selectors.dot)],
        contentSlider: document.querySelector(this.selectors.contentSlider),
      };

      this.maxIndex = this.elements.dots?.length - 1;

      this.settingsDots = {
        slidesPerView: 'auto',
      };

      this.settingsContent = {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
      };

      this.init();
    }

    /**
     * Init.
     * @returns {Void}
     */
    init() {
      if (!this.elements.contentSlider || !this.elements.dotsSlider) {
        return;
      }

      this.contentSlider = new Swiper(
        this.elements.contentSlider,
        this.settingsContent,
      );
      this.dotsSlider = new Swiper(this.elements.dotsSlider, this.settingsDots);

      this.attachEvents();
      this.updateArrowsState();
    }

    /**
     * Attach events.
     * @returns {Void}
     */
    attachEvents() {
      this.elements.arrows.arrowLeft?.addEventListener('click', () => {
        this.activeIndex = this.activeIndex - 1;
        this.goToIndex();
      });

      this.elements.arrows.arrowRight?.addEventListener('click', () => {
        this.activeIndex = this.activeIndex + 1;
        this.goToIndex();
      });

      this.elements.dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          this.activeIndex = e.target.getAttribute('data-index');
          this.goToIndex();
        });
      });

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          this.activeIndex = e.target?.getAttribute('data-index');
          this.goToIndex();
        });
      }
    }

    /**
     * Go to index.
     * @param {Number} index New active slide index
     */
    goToIndex(index = this.activeIndex) {
      this.elements.dots.forEach((dot) => {
        const dotIndex = dot.getAttribute('data-index');

        if (dotIndex == index) {
          dot.setAttribute('active', true);
          return;
        }

        dot.removeAttribute('active');
      });

      // Slides change width + transition, that should be accounted for.
      setTimeout(() => {
        this.dotsSlider.updateSlides();
        this.dotsSlider.slideTo(index);
      }, 100);

      this.updateContents();
      this.updateArrowsState();
    }

    /**
     * Update contents.
     * @returns {Void}
     */
    updateContents() {
      this.contentSlider.slideTo(this.activeIndex);

      const currentActiveMedia =
        this.elements.mediaWrapper?.querySelector('.active');
      const newActiveMedia = this.elements.mediaWrapper?.querySelector(
        `[data-index="${this.activeIndex}"]`,
      );

      if (
        currentActiveMedia == newActiveMedia ||
        !currentActiveMedia ||
        !newActiveMedia
      ) {
        return;
      }

      currentActiveMedia.classList.remove('active');
      newActiveMedia.classList.add('active');
    }

    /**
     * Update arrows state.
     */
    updateArrowsState() {
      const isFirstIndex = this.activeIndex == 0;
      const isLastIndex = this.activeIndex == this.maxIndex;

      this.elements.arrows.arrowLeft.toggleAttribute('disabled', isFirstIndex);
      this.elements.arrows.arrowRight.toggleAttribute('disabled', isLastIndex);
    }
  }
  customElements.define('experts-slider', ExpertsSlider);
}
